import { ComponentPropsWithoutRef } from 'react';
import { StyledTBody } from './styles';

export const TBody = (props: ComponentPropsWithoutRef<'tbody'>) => <StyledTBody {...props} />;
